import { typeIconMap } from './typeIcons';
import { IconMappingData } from '../types/search.types';

export const searchCategories: IconMappingData[] = [
  {
    key: '',
    label: 'All Sources',
    icon: typeIconMap.All,
  },
  {
    key: 'software-catalog',
    label: 'Software Catalog',
    icon: typeIconMap.Catalog,
    filters: [
      {
        key: 'System',
        label: 'Systems',
        icon: typeIconMap.System,
      },
      {
        key: 'Component',
        label: 'Components',
        icon: typeIconMap.Component,
      },
      {
        key: 'API',
        label: 'APIs',
        icon: typeIconMap.API,
      },
      {
        key: 'AiResource',
        label: 'AI Resource',
        icon: typeIconMap.AiResource,
      },
      {
        key: 'Resource',
        label: 'Resources',
        icon: typeIconMap.Resource,
      },
      {
        key: 'Template',
        label: 'Templates',
        icon: typeIconMap.Template,
      },
      {
        key: 'Domain',
        label: 'Domains',
        icon: typeIconMap.Domain,
      },
      {
        key: 'Group',
        label: 'Groups',
        icon: typeIconMap.Group,
      },
      {
        key: 'User',
        label: 'Users',
        icon: typeIconMap.User,
      },
    ],
  },
  {
    key: 'announcements',
    label: 'Updates',
    icon: typeIconMap.announcements,
  },
  {
    key: 'techdocs',
    label: 'Docs',
    icon: typeIconMap.techdocs,
  },
  {
    key: 'confluence',
    label: 'Confluence',
    icon: typeIconMap.confluence,
  },
];

export const SEARCH_TYPES = {
  TECHDOCS: 'techdocs',
  CATALOG: 'software-catalog',
  CONFLUENCE: 'confluence',
  ANNOUNCEMENT: 'announcements',
  AIRESOURCE: 'AiResource',
};

export const SEARCH_TYPES_NAMES = {
  [SEARCH_TYPES.TECHDOCS]: 'Docs',
  [SEARCH_TYPES.CATALOG]: 'Software Catalog',
  [SEARCH_TYPES.CONFLUENCE]: 'Confluence',
  [SEARCH_TYPES.ANNOUNCEMENT]: 'Updates',
  [SEARCH_TYPES.AIRESOURCE]: 'AI Resource',
};

export const getDisplayType = (type: string, kind?: string) => {
  switch (type) {
    case SEARCH_TYPES.CATALOG:
      return kind;
    case SEARCH_TYPES.ANNOUNCEMENT:
      return 'updates';
    case SEARCH_TYPES.TECHDOCS:
      return 'Docs';
    default:
      return type;
  }
};

// path: 'spec.system',

export const OWNERPICKER = {
  title: 'Owner',
  path: 'relations.ownedBy',
  navPath: 'owner',
};

export const SYSTEMPICKER = {
  title: 'System',
  path: 'spec.system',
  navPath: 'system',
};

export const LIFECYCLEPICKER = {
  title: 'Lifecycle',
  path: 'spec.lifecycle',
  navPath: 'lifecycle',
};

export const TAGPICKER = {
  title: 'Tags',
  path: 'metadata.tags',
  navPath: 'tags',
};

export const TYPEPICKER = {
  title: 'Type',
  path: 'spec.type',
  navPath: 'type',
};
export const filtersNotListedCategory = {
  owner: ['group', 'user', 'confluence'],
  lifecycle: [
    'domain',
    'system',
    'resource',
    'template',
    'group',
    'user',
    'announcements',
    'techdocs',
  ],
  system: [
    'domain',
    'system',
    'resource',
    'template',
    'group',
    'user',
    'announcements',
    'techdocs',
  ],
  type: [
    'system',
    'api',
    'component',
    'resource',
    'group',
    'user',
    'announcements',
  ],
  tags: ['resource', 'user', 'announcements'],
};

export const SearchPageText = {
  filterBy: 'Filter by',
  emptyTermTitle: 'No Search Term',
  emptyTermDesc:
    'Looks like you’ve cleared your input. Type something new to see results.',
  editedText: 'Edited: $lastModifiedDate by $lastModifiedBy',
};
